import types from 'constants/actionTypes';

const initialState = {
  dashboard: { stale: false, loaded: false },
  dealershipAllocation: { stale: false, loaded: false },
  cartQuantity: { stale: false, loaded: false },
  modelsViewers: { stale: false, loaded: false },
  modelTemplatesWorkingState: {},
  seriesPipeline: {},
};

const dataStatus = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (type) {
    case types.GET_DASHBOARD_REQUEST_SUCCESS:
      return { ...state, dashboard: { stale: false, loaded: true } };
    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS:
      return { ...state, dealershipAllocation: { stale: false, loaded: true } };
    case types.GET_TOTAL_CART_QUANTITY_REQUEST_SUCCESS:
      return { ...state, cartQuantity: { stale: false, loaded: true } };
    case types.GET_MODELS_VIEWERS_REQUEST_SUCCESS:
      return { ...state, modelsViewers: { stale: false, loaded: true } };
    case types.GET_SERIES_PIPELINE_REQUEST_SUCCESS:
      let seriesId = payload.seriesId;
      const seriesPipelineStatus = {};
      seriesPipelineStatus[seriesId] = { stale: false, loaded: true };
      let updatedSeriesPipelineStatuses = Object.assign(
        state.seriesPipeline,
        seriesPipelineStatus,
      );
      return {
        ...state,
        seriesPipeline: updatedSeriesPipelineStatuses,
      };
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST_SUCCESS:
      let modelId = payload.result.model;
      const modelWorkingStateStatus = {};
      modelWorkingStateStatus[modelId] = { stale: false, loaded: true };
      let updatedModelTemplatesWorkingState = Object.assign(
        state.modelTemplatesWorkingState,
        modelWorkingStateStatus,
      );
      return {
        ...state,
        modelTemplatesWorkingState: updatedModelTemplatesWorkingState,
      };
    default:
      return state;
  }
};

export default dataStatus;
